import { create, valueOf } from 'microstates';
import AppState from './app-state';

export default class HistoryState {
  value = Array;

  track(x) {
    return this.value.unshift(x);
  }

  undo() {
    return this.value.shift();
  }

  get current() {
    const prevState =  valueOf(this.value)[0];
    return create(AppState, prevState);
  }
}
